module.exports = {"id":"190461","name":"Björn Bergmann Sigurðarson","rating":"73","photo":"./data/images/photos/1/190461.png","club":{"name":"FK Rostov","logo":"./data/images/clubs/FKRostov.png"},"positions":["BU","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BjornBergmannSigurðarson0.json
// module id = 606
// module chunks = 0